import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { getSummary } from "../service";

export const useGetSummary = (params, options) => {
  return useQuery(
    [queryKey.SUMMARY, params],
    () => getSummary({ ...params }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};
